<!--NAV BAR-->
<app-navbar>
</app-navbar>
<div class="store-page-overlay"></div>

<div class="container-fluid">
  <div class="row row-sm-offset">

    <div class="col-md-12">
      <div class="store-content">
        <div class="store-inner">
          <div *ngIf="roles.isSuperAdmin" (click)="openModal(0)" class="float-right mr-4 btn btn-success">
            <i class="fas fa-plus"></i> Add
          </div>
          <h4 class="checkout-heading">
            Manage Namespace
          </h4>
          <p class="text-black-50 mt-4">Add/Update/Delete Azure Namespaces</p>
        </div>
      </div>

      <div class="row mt-3">
        <div *ngIf="filterId > 0" class="col-md-12 mb-3">
          <div class="mb-5">
            <button (click)="removeFilter()" class="btn btn-secondary float-right"><i class="fas fa-minus"></i>
              Remove Filter</button>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="table-responsive-sm">
            <table style="width: 100% !important;background-color: #FFF;" class="table table-striped ">
              <thead class="thead-dark bg-info">
                <th scope="col">#</th>
                <th scope="col">Namespace</th>
                <th scope="col">Azure Account</th>
                <th scope="col">Location</th>
                <th scope="col">Resource Group</th>
                <th class="text-center" scope="col">Total Endpoints</th>
                <th class="text-center" scope="col">Active?
                  <div class="helper-dude">
                    <i placement="top"
                      ngbPopover="Active status is internal to our database. When inactive, client can no longer use this relay connection. It can be a good way to stop a client from using a Relay connection temporarily"
                      popoverTitle="What is this?" class="far fa-question-circle"></i>
                  </div>
                </th>
                <th class="text-center" scope="col">Azure's Status
                  <div class="helper-dude">
                    <i placement="top"
                      ngbPopover="Azure status is something we need to fetch from Microsoft Azure. When a new namespace is creted, it is not available immediately and as a result, we need its status before we can use it for endpoints."
                      popoverTitle="What is this?" class="far fa-question-circle"></i>
                  </div>
                </th>
                <th *ngIf="roles.isSuperAdmin" class="text-center" scope="col">Manage</th>
              </thead>
              <tr *ngFor="let namespace of namespaces">
                <th scope="row">
                  {{namespace.Id}}
                </th>
                <td>
                  {{namespace.AzureNamespace}}
                </td>
                <td>
                  {{namespace.AzureAccount}}
                </td>
                <td>
                  {{namespace.Location}}
                </td>
                <td>
                  {{namespace.ResourceGroup}}
                </td>
                <td class="text-center">
                  {{namespace.RelatedEndpointsCount}}
                </td>
                <td *ngIf="namespace.Active" class="text-center">
                  Yes
                </td>
                <td *ngIf="!namespace.Active" class="text-center">
                  No
                </td>
                <td class="text-center" *ngIf="namespace.Status">
                  Active
                </td>
                <td class="text-center text-danger" *ngIf="!namespace.Status">
                  Activating
                </td>
                <td *ngIf="roles.isSuperAdmin" class="text-center">
                  <i (click)="openModal(namespace.Id)" class="fad fa-pencil-alt icon-btn text-prime"></i>
                  <i (click)="deleteNamespace(namespace.Id)" class="fad fa-trash-alt icon-btn text-danger"></i>
                  <i *ngIf="!namespace.Status" (click)="refreshNamespaceWithAzure(namespace.Id)"
                    title="Get activation status from Microsoft Azure" class="fad fa-sync-alt icon-btn text-info"></i>
                </td>
              </tr>

            </table>
          </div>

          <div class="btn-paging-container">
            <ng-container *ngIf="pager.totalItems > 0">
              <div>
                <button (click)="getNextRecordsBatch(false)" class="btn-paging prev"><i
                    class="fas fa-chevron-left"></i></button>

                <ng-container *ngFor="let page of pager.pages">
                  <button (click)="fetchSpecificPage(page)" [ngClass]="{'active': page == pager.currentPage}"
                    class="btn-paging">{{page}}</button>
                </ng-container>

                <button (click)="getNextRecordsBatch(true)" class="btn-paging next"><i
                    class="fas fa-chevron-right"></i></button>
              </div>

            </ng-container>
          </div>
        </div>

      </div>

      <div (click)="logout()" class="log-out">
        <i class="fas fa-sign-out-alt"></i>Log out
      </div>
    </div>



  </div>
</div>

<div *ngIf="isShowSuccess" class="fixed-success">
  <div (click)="closeSuccess()" class="float-right">
    <i class="fas fa-times"></i>
  </div>
  {{successMessage}}
</div>

<div *ngIf="isShowError" class="fixed-error">
  <div (click)="closeError()" class="float-right">
    <i class="fas fa-times"></i>
  </div>
  {{errorMessage}}
</div>

<app-powered-by></app-powered-by>
